<template>
    <LazyIcon
        v-bind:name="name"
        v-bind:class="classes"
        v-bind:style="style"
        class="svgIcon"
    />
</template>

<script lang="ts" setup>
    import type { IconName } from '@sbo/icons-vue';
    import { LazyIcon } from '@sbo/icons-vue';
    import type { CSSProperties } from 'vue';
    import { computed } from 'vue';

    interface Props {
        name: IconName;
        // can be size: sm, md, lg, ...
        // or size in pixels: 16, 24, 32, ...
        size?: number | string;
        // can be color: white, red, ...
        color?: string;
        rotated?: boolean;
        rotating?: boolean;
        left?: boolean;
        right?: boolean;
        pointer?: boolean;
        style?: CSSProperties;
    }

    const props = withDefaults(defineProps<Props>(), {
        size: 'default',
        color: '',
        rotated: false,
        rotating: false,
        left: false,
        right: false,
        pointer: false,
        style: () => ({}),
    });

    const classes = computed(() => {
        const result = [];

        if (props.size && Number.isNaN(Number(props.size))) result.push(`svgIcon-${props.size}`);

        if (props.color) result.push(`svgIcon-${props.color}`);

        if (props.rotated && !props.rotating) result.push('rotated');

        if (props.rotating) result.push('rotating');

        if (props.pointer) result.push('svgIcon-pointer');

        if (props.left) result.push('svgIcon-left');
        else if (props.right) result.push('svgIcon-right');

        return result;
    });

    const style = computed<CSSProperties>(() => {
        if (Number.isNaN(Number(props.size))) {
            return props.style;
        }

        return {
            width: `${props.size}px`,
            height: `${props.size}px`,
            minWidth: `${props.size}px`,
            minHeight: `${props.size}px`,
            ...props.style,
        };
    });
</script>

<style lang="scss" scoped>
    @import "@/components/common/SvgIcon";
</style>
